import { Component, OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { SidebarService } from '@ibe/services/ui';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-alert',
  templateUrl: './payment-alert.indra.component.html',
  styleUrls: ['./payment-alert.indra.component.scss']
})
export class INDRAPaymentAlertComponent extends AbstractModalContentComponent implements OnInit {

	public modalType: string;
	constructor(
		protected modalService: ModalService,
		protected router: Router,
		private sidebarService: SidebarService
	) {
		super(modalService);
	}

	ngOnInit() {
		this.modalType =  this.modalService.params[2];
	}

	actionButton() {
		const pnr = this.modalService.params[0];
		const lastname = this.modalService.params[1];
		if (this.modalType === 'paymentAlert') {
			this.router.navigate(['/my-bookings/details', pnr, lastname]);
		} else if (this.modalType === 'bookingPaymentAlert') {
			this.router.navigate(['/my-bookings/view', pnr, lastname]);
		} else if (this.modalType === 'emailAlert'){
			this.sidebarService.openSidebar(['contacts', { pnr: pnr }]);
		}

		this.closeModal();

	}

	closeModal() {
		this.modalService.close();
	}
}
